import axios from "axios";
import Config from "../../../config";

const v2_actionEditLeadTag = (tagId, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/crm/lead-tags/${tagId}/editar`,
        data
    });
};

export default v2_actionEditLeadTag;
